import AppModal from './AppModal';
import AppModalHeader from "./AppModalHeader";
import Button from "./Button";
import { memo } from "react";

const DeleteConnection = ({
  id,
  confirmModal,
  setConfirmModal,
  onConfirmModal,
  onCancelModal,
  imgSrc = "/assets/svg/deletelogo.svg",
  altText = "DeleteLogo",
  description = "If you delete this connection, you have two options to select below.",
  keepDataText = "Keep Data",
  overwriteText = "Overwrite",
  overwriteBgColor = "bg-[#115B9D]-2",
  label = "Delete",
}) => {

  return (
    <AppModal
      isOpen={confirmModal}
      onClose={onCancelModal}
      className="!max-w-[440px]"
    >
      <AppModalHeader label={label} onClose={onCancelModal} />
      <div className="py-6 px-8 gap-2 text-center">
        <div className="flex justify-center">
          <img src={imgSrc} alt={altText} />
        </div>
        <p className="pt-3 text-black-2 text-sm font-normal">{description}</p>
        <div className="flex items-center justify-center gap-2 pt-10">
          <Button
            className="border border-gray-5 !rounded-md w-[164px] !h-10 !p-1 !font-normal !text-black-2 group !bg-transparent hover:!bg-[#115B9D]-2 hover:!text-white"
            onClick={() => setConfirmModal()}
          >
            {keepDataText}
          </Button>
          <Button
            className={`w-[164px] !h-10 ${overwriteBgColor} hover:opacity-90 text-white`}
            onClick={async () => { await onConfirmModal(); setConfirmModal(); }}
          >
            {overwriteText}
          </Button>
        </div>
      </div>
    </AppModal>
  );
};

export default memo(DeleteConnection);
